import { useEffect, useState } from 'react'

export function useMobilePortrait() {
  const [isMobilePortrait, setIsMobilePortrait] = useState(false)

  useEffect(() => {
    const checkOrientation = () => {
      const isMobile = window.matchMedia('(max-width: 768px)').matches
      const isPortrait = window.matchMedia('(orientation: portrait)').matches
      setIsMobilePortrait(isMobile && isPortrait)
    }

    // Initial check
    checkOrientation()

    // Add event listeners
    const portraitMql = window.matchMedia('(orientation: portrait)')
    const mobileMql = window.matchMedia('(max-width: 768px)')

    portraitMql.addListener(checkOrientation)
    mobileMql.addListener(checkOrientation)

    // Cleanup
    return () => {
      portraitMql.removeListener(checkOrientation)
      mobileMql.removeListener(checkOrientation)
    }
  }, [])

  return isMobilePortrait
}
